// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"29512fcf","940":"7cd4e0d3"}[chunkId] + ".chunk.js";
};